import { CheckCircle, XCircle } from 'lucide-react';

interface Framework {
  key: string;
  name: string;
  description: string;
}

const FRAMEWORKS: Framework[] = [
  { key: 'celestial_toad', name: 'Celestial Toad v4', description: 'CT 技能框架' },
  { key: 'hermes', name: 'Hermes', description: 'HTTP API 代理框架' },
  { key: 'openclaw', name: 'OpenClaw', description: '开放爪牙框架' },
  { key: 'openhuman', name: 'OpenHuman', description: '拟人交互框架' },
  { key: 'opencode', name: 'OpenCode', description: '开源终端 AI Coding Agent' },
  { key: 'generic', name: 'Generic', description: '通用导出' },
];

export interface CompatibilityInfo {
  compatible: boolean;
  issues: string[];
}

interface FrameworkPickerProps {
  selected: string;
  onSelect: (key: string) => void;
  compatibility?: Record<string, CompatibilityInfo>;
}

export default function FrameworkPicker({ selected, onSelect, compatibility }: FrameworkPickerProps) {
  return (
    <div
      className="grid gap-3"
      style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' }}
    >
      {FRAMEWORKS.map((fw) => {
        const compat = compatibility?.[fw.key];
        const isSelected = selected === fw.key;
        const isDisabled = compat ? !compat.compatible : false;

        return (
          <div
            key={fw.key}
            className="card"
            onClick={() => !isDisabled && onSelect(fw.key)}
            style={{
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              padding: 16,
              opacity: isDisabled ? 0.5 : 1,
              borderColor: isSelected ? 'var(--color-primary)' : undefined,
              boxShadow: isSelected ? '0 0 0 2px var(--color-primary)' : undefined,
              transform: isSelected ? 'translateY(-2px)' : undefined,
            }}
          >
            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>
              {fw.name}
            </div>
            <div className="text-muted" style={{ fontSize: 12 }}>
              {fw.description}
            </div>
            {compat && (
              <div className="flex items-center gap-1 mt-2" style={{ fontSize: 12 }}>
                {compat.compatible ? (
                  <>
                    <CheckCircle size={12} style={{ color: 'var(--color-success)' }} />
                    <span style={{ color: 'var(--color-success)' }}>兼容</span>
                  </>
                ) : (
                  <>
                    <XCircle size={12} style={{ color: 'var(--color-error)' }} />
                    <span style={{ color: 'var(--color-error)' }}>不兼容</span>
                  </>
                )}
              </div>
            )}
            {compat && !compat.compatible && compat.issues.length > 0 && (
              <div style={{ fontSize: 11, color: 'var(--color-error)', marginTop: 4 }}>
                {compat.issues[0]}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
